import { accessibleShade, typeSize } from "@coaching-culture/ui";
import { lighten } from "polished";
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
html,
body,
#root {
  height: 100%;
  min-height: 100%;
}

html {
  font-size: ${typeSize("body")};
  overflow-y: scroll;
}

@media print {
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }

  body
  {
    margin: 25mm 25mm 25mm 25mm;
  }
  
}

@page {
  size: auto;
  margin: 15mm;
}

body, button, input, textarea, select {
  font-family: ${(props) => props.theme.fonts.body};
    font-size: ${(props) => props.theme.fontSizes[3]}px;
  line-height: ${(props) => props.theme.baseLineHeight};
  padding: 0;
  margin: 0;
  color: ${(props) => props.theme.colors.body};
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

table {
  font-variant-numeric: tabular-nums;
}

h1,
h2,
h3,
h4,
h5,
h6,
pre,
p {
  margin: 0;
  font-family: ${(props) => props.theme.fonts.body};
    font-size: ${(props) => props.theme.fontSizes[3]}px;
  line-height: ${(props) => props.theme.baseLineHeight};
  font-weight: normal;
}

h1,
h2,
h3,
h4,
h5,
  h6 {
  font-family: ${(props) => props.theme.fonts.heading};
  letter-spacing: -0.01em;
  }

*,
*:before,
*:after {
  box-sizing: border-box;
}

/* Links use the accent, deepened if it's too light to read on white. */
a {
  color: ${(props) => accessibleShade(props.theme.colors.primary)};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

}

/* A link wrapped round an avatar (often a whole UserFlag) underlines only
   the person's name on hover, never the initials in the circle. */
a:has(.cc-avatar):hover {
  text-decoration: none;
}

a:has(.cc-avatar):hover .cc-user-name {
  text-decoration: underline;
}

.react-datepicker-popper {
  z-index: 100;
}

.react-datepicker {
  border-color: transparent;
  border-top: 3px solid ${(props) => props.theme.colors.primary};
  font-family: ${(props) => props.theme.fonts.body};
  border-radius: 0;
  box-shadow: ${(props) => props.theme.shadows[2]};
}
.react-datepicker__triangle {
  display: none;
}

.react-datepicker__time-container {
  border-left-color: ${(props) => props.theme.colors.border};
}

.react-datepicker__navigation {
  top: 7px;
}

.react-datepicker__header {
  padding-top: 6px;
  background-color: ${(props) => props.theme.colors.sunken};
  border-bottom-color: ${(props) => props.theme.colors.border};
}

.react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header,
.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name
{
  color: ${(props) => props.theme.colors.body};
}

.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
  background-color: ${(props) => props.theme.colors.surface};
  color: ${(props) => props.theme.colors.body};
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected, .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range
{
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.surface};

  &:hover {
    background-color: ${(props) => lighten(0.2, props.theme.colors.primary)};
  }
}

.react-datepicker__day--disabled, .react-datepicker__month-text--disabled, .react-datepicker__quarter-text--disabled, .react-datepicker__year-text--disabled {
  color: ${(props) => props.theme.colors.borderStrong};
}

  .use-spring-carousel-item {
    min-width: 0;
    min-height: 0;
  }

  .react-tiny-popover-container {
    z-index: 100000;
  }

@media print {
    @page {
      margin: 2cm;
    }

    body {
      font: 13pt Georgia, "Times New Roman", Times, serif;
      line-height: 1.3;
      background: #fff !important; /* print on plain paper, design-lint-ignore */
      color: #000; /* print in black ink, design-lint-ignore */
    }

    a {
      page-break-inside: avoid;
    }
    blockquote {
      page-break-inside: avoid;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      page-break-after: avoid;
      page-break-inside: avoid;
    }

  h1 {
    page-break-before: always
  }
    img {
      page-break-inside: avoid;
      page-break-after: avoid;
    }
    table,
    pre {
      page-break-inside: avoid;
    }
    ul,
    ol,
    dl {
      page-break-before: avoid;
    }
  }
`;

export default GlobalStyle;
